import { useSyncExternalStore } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import i18n from "./i18n";

let initialization: Promise<void> | undefined;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((listener) => listener());
const currentLanguage = () => (i18n.resolvedLanguage || "de").split("-")[0];

export function initializeCookieConsent() {
  if (!initialization) {
    initialization = CookieConsent.run({
      mode: "opt-in",
      cookie: { name: "rss_cookie_consent", expiresAfterDays: 182 },
      guiOptions: {
        consentModal: { layout: "box", position: "bottom right", equalWeightButtons: true },
        preferencesModal: { layout: "box", equalWeightButtons: true },
      },
      categories: {
        necessary: { enabled: true, readOnly: true },
        external: {},
      },
      onConsent: notify,
      onChange: notify,
      language: {
        default: currentLanguage(),
        translations: Object.fromEntries(["de", "en", "fr", "es"].map((language) => [
          language,
          i18n.getResource(language, "translation", "cookieConsent"),
        ])),
      },
    });
    i18n.on("languageChanged", () => {
      void initialization?.then(() => CookieConsent.setLanguage(currentLanguage()));
    });
  }
  return initialization;
}

export async function showCookiePreferences() {
  await initializeCookieConsent();
  CookieConsent.showPreferences();
}

export function useExternalMediaConsent() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => { listeners.delete(listener); };
    },
    () => CookieConsent.acceptedCategory("external"),
    () => false,
  );
}
